// extracted by mini-css-extract-plugin
export var buyButton = "VariantGrid-module--buy-button--526e9";
export var imageHover = "VariantGrid-module--imageHover--3756f";
export var imageIsSoldOut = "VariantGrid-module--image-is-sold-out--2f128";
export var imageMain = "VariantGrid-module--imageMain--6d9c5";
export var imageWrapper = "VariantGrid-module--imageWrapper--a25a9";
export var isSale = "VariantGrid-module--isSale--bd9be";
export var itemWrapper = "VariantGrid-module--itemWrapper--e3542";
export var itemWrapperHemX = "VariantGrid-module--itemWrapperHemX--46ed4";
export var itemWrapperRow = "VariantGrid-module--itemWrapperRow--227a2";
export var lastRow = "VariantGrid-module--last-row--32c31";
export var mat = "VariantGrid-module--mat--67c87";
export var mats = "VariantGrid-module--mats--9a579";
export var onSalePill = "VariantGrid-module--on-sale-pill--610dc";
export var section = "VariantGrid-module--section--b0836";
export var shimmer = "VariantGrid-module--shimmer--9d6b7";
export var skeleton = "VariantGrid-module--skeleton--ea1e9";
export var skeletonImage = "VariantGrid-module--skeleton-image--4c4fd";
export var variantNameWrapper = "VariantGrid-module--variantNameWrapper--714ea";
export var wrapper = "VariantGrid-module--wrapper--7797f";